// Module
var code = `<iframe ng-src="{{ \$ctrl.frameUrl }}" width="100%" height="100%" scrolling="no" frameborder="0" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe> `;
// Exports
module.exports = code;